exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".area-grid-item {\n    color: #373a3c; \n}\n\n.area-grid-topic {\n    font-size: 24pt;\n}\n\n.area-item-selected {\n    color: rgb(2, 117, 216);\n    background: rgb(2, 117, 216);\n    border-radius: 0.25em;\n}\n\n.area-grid-selected .ui-panel-titlebar {\n    background-color: rgb(2, 117, 216);\n}\n\np.area-grid-topic {\n    margin-bottom: 5px;\n    margin-top: 5px;\n}\n\n.clickable {\n    -webkit-transition: all .2s ease-in;\n    transition: all .2s ease-in;\n}\n\n.clickable:hover {\n    background: rgb(2, 117, 216);\n    color: #fff;\n    border-radius: .25em;\n    padding: 3px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/area/area.component.css
// module id = ../../../../../src/app/area/area.component.css
// module chunks = main